import MainLayout from "../components/layout/MainLayout";
import MainLayoutUser from "../components/layout/MainLayoutUser";
import MainLayoutAdmin from "../components/layout/MainLayoutAdmin";
import BannerStatic from "../components/organisms/BannerStatic";
import JobListingGrid from "../components/organisms/JobListingGrid";
import BannerJobSearch from "../components/organisms/BannerJobSearch";
import { useEffect } from "react";
import { useAuthStore } from "../store/useAuthStore";

export default function Jobs() {
  const { accessToken, type } = useAuthStore();
  useEffect(() => {
    document.title = "TalentLink | Jobs";

    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", "Halaman utama TalentLink");
    }
  }, []);

  const Layout =
    !accessToken
      ? MainLayout
      : type === "candidate"
        ? MainLayoutUser
        : type === "company"
          ? MainLayoutAdmin
          : MainLayout;

  return (

    <Layout>
      <BannerStatic blur>
        <BannerJobSearch />
      </BannerStatic>
      <JobListingGrid />
    </Layout>
  );
}
